<template>
      <div class="settings-layout details-layout">
        <form>
            <div class="form-section">
                <div class="registration-page-title">Profile info</div>
            </div>
           <AvatarUpload @callback="storeLogo" :image-url="''" :validation="v$.logo"/>
            <div class="form-section">

                <div class="form-group w-80">
                    <label>SELECT CATEGORY</label>
                    <div class="select-cover">
                        <select name="category_id" id="category_id" v-model="category" @change="submit" :class="{'not-selected': category == ''}">
                            <option value="" disabled>Select Category</option>
                            <template v-for="(category, index) in categories" :key="index">
                                <option v-if="(formData.countryCode == 'US') || (index != '57c7c424bd12x' && formData.countryCode != 'US')" :value="index">{{category}}</option>
                            </template>
                        </select>
                    </div>
                    <FormError :validationStatus="v$.category"/>
                </div>

                <div class="w-flex-80">
                    <div class="form-group">
                        <label>CONTACT NAME</label>
                        <div class="input-group-cover">
                            <input type="text" @input="submit" placeholder="First name" name="first_name" id="first_name" v-model="firstName" @blur="v$.firstName.$touch()">
                        </div>
                        <FormError :validationStatus="v$.firstName"/>
                    </div>

                    <div class="form-group" style="margin-left: 15px;">
                        <label style="color: #FFFFFF !important;">-</label>
                        <div class="input-group-cover">
                            <input type="text" @input="submit" placeholder="Last name" name="last_name" id="last_name"  v-model="lastName" @blur="v$.lastName.$touch()">
                        </div>
                        <FormError :validationStatus="v$.lastName"/>
                    </div>
                </div>

                <div class="form-group w-80">
                    <label>WEBSITE</label>
                    <div class="input-group-cover">
                        <input type="text" @input="submit" name="website_url" id="website_url" placeholder="https://mystore.com.au" v-model="website" @blur="v$.websiteUrl.$touch()">
                    </div>
                    <FormError :validationStatus="v$.websiteUrl"/>
                </div>

                <div class="form-group w-80" style="height: 150px;">
                    <label>PROFILE DESCRIPTION</label>
                    <div class="input-group-cover">
                        <textarea id="bio" style="height:120px;" @input="submit" name="bio" placeholder="Biography / Description" v-model="storeDescription" @blur="v$.storeDescription.$touch()"></textarea>
                    </div>
                    <FormError :validationStatus="v$.storeDescription"/>
                </div>
                <div class="form-group w-80 sub-period-selection" v-if="formData.businessType == 'Gold Partner'">
                    <label>DO YOU HAVE A PHYSICAL STORE LOCATION</label>
                    <div class="option-wrap ui buttons big display-left">
                        <button type="button" 
                            class="ui button toggle"
                            @click="togglePhysicalStore(); submit()"
                            :class="[hasStore ? 'active' : 'plan-selected']"
                            :disabled="!hasStore"
                        >No</button>
                        <button type="button"  
                            class="ui button toggle"
                            @click="togglePhysicalStore(); submit()"
                            :class="[!hasStore ? 'active' : 'plan-selected']"
                            :disabled="hasStore"
                        >Yes</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import AvatarUpload from './../../AvatarUpload.vue';
import FormError from './../../FormError.vue';
import { required, minLength, maxLength, url, requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export default {
    setup(){
        return { v$: useVuelidate() }
    },
    name: "StoreDetails",
    components: {AvatarUpload, FormError},
    props: ['categories', 'url', 'formData', 'type', 'physicalStore'],
    emits: ["update"],
    data(){
        return{
            category: "",
            firstName: "",
            lastName: "",
            storeDescription: "",
            website: "",
            logo: "",
            hasStore: this.physicalStore
        }
    },
    computed: {
        websiteUrl: function () {
          if (this.website.trim() == '') return '';

          return this.website.startsWith('http') ? this.website : `http://${this.website}`;
        }
    },
    methods:{
        submit(){
            this.$emit('update', {
                data:{
                    category: this.category,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    storeDescription: this.storeDescription,
                    website: this.websiteUrl,
                    logo: this.logo,
                    physicalStore: this.hasStore
                },
                valid: !this.v$.$invalid
            })
        },
        storeLogo(logo){
            this.logo = logo;
            this.v$.logo.$touch();
            this.submit();
        },
        togglePhysicalStore(){
            this.hasStore = !this.hasStore;
        },
    },
    validations:{
        category: {required},
        firstName: {required, minLength: minLength(2)},
        lastName: {required, minLength: minLength(2)},
        storeDescription: {minLength: minLength(5)},
        websiteUrl: {url, requiredif:requiredIf(function(){
            return this.formData.businessType == 'Gold Partner' && !this.hasStore;
        })},
        logo: {required}
        // logo: {required:requiredIf(function() {
        //     return !this.merchant.user_image || this.merchant.user_image.includes('placeholder');
        // })},
    }
}
</script>
